//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

export default {
  name: 'hero-aside-list',
  components: {
    HeroAsideListItem: () => import('@motionelements/core/src/components/artist/sections/HeroAsideListItem.vue'),
    NuxtClientOnly: () => import('@motionelements/core/src/components/nav/NuxtClientOnly.vue'),
  },
  props: {
    artist: {
      type: Object,
      required: true,
    },
    linkClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      freeMediaTypesCount: 'profile/freeMediaTypesCount',
    }),
  },
};
